(function () {
  var POPUP_KEY    = 'ck_popup_v5';
  var PREDICT_PATH = '/pages/predict-and-win';
  var API          = 'https://casekaro-api.square-meadow-38de.workers.dev';
  var WA_NUMBER    = '917021904900';

  if (window.location.pathname.indexOf(PREDICT_PATH) !== -1) return;

  function abbr(n) {
    if (!n) return '??';
    var w = n.trim().split(' ');
    return w.length === 1 ? n.substring(0,3).toUpperCase() : w.map(function(x){ return x[0]; }).join('').substring(0,3).toUpperCase();
  }

  var bubbleEl, overlayEl;
  var cdTimer = null;
  var paxTimer = null;

  // ── CSS ──────────────────────────────────────────────────────────
  var CSS = [
    "@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@400;500;600;700&display=swap');",
    "#ck-predict-bubble{position:fixed;bottom:16px;left:14px;z-index:99999;display:flex;align-items:center;gap:0;cursor:pointer;user-select:none;transition:transform .2s ease,opacity .3s ease;}",
    "#ck-predict-bubble:hover{transform:scale(1.05);}",
    "#ck-predict-bubble:active{transform:scale(.95);}",
    "#ck-predict-bubble.ck-hidden{opacity:0;pointer-events:none;transform:scale(.8);}",
    ".ck-bubble-icon{width:52px;height:52px;border-radius:50%;background:linear-gradient(135deg,#6C2BD9 0%,#9b59f7 100%);display:flex;align-items:center;justify-content:center;box-shadow:0 4px 20px rgba(108,43,217,.35),0 0 0 0 rgba(108,43,217,.4);animation:ck-bubble-pulse 2.5s ease-in-out infinite;position:relative;flex-shrink:0;}",
    "@keyframes ck-bubble-pulse{0%,100%{box-shadow:0 4px 20px rgba(108,43,217,.35),0 0 0 0 rgba(108,43,217,.4);}50%{box-shadow:0 4px 20px rgba(108,43,217,.35),0 0 0 10px rgba(108,43,217,0);}}",
    ".ck-bubble-emoji{font-size:24px;line-height:1;filter:drop-shadow(0 2px 4px rgba(0,0,0,.2));}",
    ".ck-bubble-badge{position:absolute;top:-2px;right:-2px;width:16px;height:16px;border-radius:50%;background:#2ecc71;border:2.5px solid #fff;display:flex;align-items:center;justify-content:center;}",
    ".ck-bubble-badge-dot{width:6px;height:6px;border-radius:50%;background:#fff;animation:ck-blink 1.2s infinite;}",
    "#ck-predict-overlay{position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,.65);display:flex;align-items:flex-end;justify-content:center;opacity:0;pointer-events:none;transition:opacity .35s ease;}",
    "#ck-predict-overlay.ck-on{opacity:1;pointer-events:all;}",
    "#ck-popup{width:100%;max-width:430px;background:#f0ede8;border-radius:24px 24px 0 0;overflow:hidden;font-family:'DM Sans',sans-serif;transform:translateY(100%);transition:transform .45s cubic-bezier(.22,1,.36,1);max-height:80vh;overflow-y:auto;}",
    "#ck-predict-overlay.ck-on #ck-popup{transform:translateY(0);}",
    ".ck-drag{display:flex;justify-content:center;padding:10px 0 2px;}",
    ".ck-drag-bar{width:36px;height:4px;border-radius:2px;background:#d4cfc6;}",
    "@keyframes ck-float{0%,100%{transform:translateY(0) rotate(-4deg)}50%{transform:translateY(-10px) rotate(4deg)}}",
    "@keyframes ck-pulse{0%,100%{box-shadow:0 0 0 0 rgba(244,161,0,.5)}70%{box-shadow:0 0 0 18px rgba(244,161,0,0)}}",
    "@keyframes ck-blink{0%,100%{opacity:1}50%{opacity:.3}}",
    "@keyframes ck-spin{to{transform:rotate(360deg)}}",
    ".ck-ph{background:#111;padding:12px 16px;display:flex;align-items:center;justify-content:space-between;gap:10px;}",
    ".ck-logo{font-family:'Bebas Neue',sans-serif;font-size:20px;letter-spacing:3px;color:#f0ede8;}",
    ".ck-logo em{color:#F4A100;font-style:normal;}",
    ".ck-live{display:flex;align-items:center;gap:5px;background:rgba(46,204,113,.12);border:1px solid rgba(46,204,113,.25);border-radius:20px;padding:3px 9px;}",
    ".ck-live-dot{width:5px;height:5px;border-radius:50%;background:#2ecc71;animation:ck-blink 1.2s infinite;}",
    ".ck-live-txt{font-size:9px;font-weight:700;letter-spacing:1px;color:#2ecc71;}",
    ".ck-close{background:rgba(255,255,255,.1);border:none;border-radius:50%;width:26px;height:26px;cursor:pointer;color:rgba(255,255,255,.4);font-size:14px;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:background .2s;}",
    ".ck-close:hover{background:rgba(255,255,255,.2);color:#fff;}",
    ".ck-hero{background:linear-gradient(160deg,#0f0528 0%,#1e0b5e 35%,#3d1499 65%,#6C2BD9 100%);padding:22px 20px 20px;position:relative;overflow:hidden;}",
    ".ck-hero::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse at 85% 15%,rgba(240,192,64,.18) 0%,transparent 55%),radial-gradient(ellipse at 10% 85%,rgba(108,43,217,.35) 0%,transparent 50%);pointer-events:none;}",
    ".ck-ring{position:absolute;right:-40px;top:-40px;width:160px;height:160px;border-radius:50%;border:1.5px solid rgba(240,192,64,.12);pointer-events:none;}",
    ".ck-ring2{position:absolute;right:-65px;top:-65px;width:210px;height:210px;border-radius:50%;border:1px solid rgba(255,255,255,.05);pointer-events:none;}",
    ".ck-hi{position:relative;z-index:1;}",
    ".ck-chip{display:inline-flex;align-items:center;gap:6px;background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.12);border-radius:20px;padding:4px 11px;margin-bottom:16px;}",
    ".ck-chip-txt{font-size:10px;color:rgba(255,255,255,.55);font-weight:500;}",
    ".ck-chip-live{font-size:10px;font-weight:700;color:#f0c040;letter-spacing:.5px;}",
    ".ck-hero-top{display:flex;align-items:flex-start;justify-content:space-between;gap:10px;margin-bottom:10px;}",
    ".ck-eyebrow{font-size:9px;font-weight:800;letter-spacing:3px;text-transform:uppercase;color:rgba(255,255,255,.4);margin-bottom:5px;}",
    ".ck-title{font-family:'Bebas Neue',sans-serif;font-size:52px;letter-spacing:1.5px;line-height:.9;color:#fff;margin-bottom:2px;}",
    ".ck-title em{color:#f0c040;font-style:normal;display:block;font-size:58px;}",
    ".ck-emoji{font-size:88px;line-height:1;flex-shrink:0;animation:ck-float 4s ease-in-out infinite;filter:drop-shadow(0 6px 16px rgba(240,192,64,.45));margin-top:-6px;}",
    ".ck-sub{font-size:12px;color:rgba(255,255,255,.55);line-height:1.65;margin-bottom:16px;}",
    ".ck-sub strong{color:rgba(255,255,255,.9);}",
    ".ck-matchup{display:flex;align-items:center;justify-content:center;gap:8px;margin-bottom:16px;}",
    ".ck-team-pill{display:flex;align-items:center;gap:6px;background:rgba(255,255,255,.1);border:1px solid rgba(255,255,255,.15);border-radius:20px;padding:5px 12px;}",
    ".ck-team-logo{width:20px;height:20px;border-radius:4px;object-fit:contain;background:rgba(255,255,255,.15);}",
    ".ck-team-name{font-size:12px;font-weight:700;color:#fff;letter-spacing:.5px;}",
    ".ck-vs{font-size:11px;color:rgba(255,255,255,.35);font-weight:600;}",
    ".ck-steps{display:flex;gap:6px;margin-bottom:16px;}",
    ".ck-step{flex:1;background:rgba(255,255,255,.07);border:1px solid rgba(255,255,255,.1);border-radius:10px;padding:9px 5px;text-align:center;}",
    ".ck-step-icon{font-size:16px;display:block;margin-bottom:4px;}",
    ".ck-step-txt{font-size:9px;color:rgba(255,255,255,.6);line-height:1.3;font-weight:500;}",
    ".ck-pts{display:flex;gap:5px;margin-bottom:16px;}",
    ".ck-pt{flex:1;background:rgba(255,255,255,.07);border:1px solid rgba(255,255,255,.1);border-radius:9px;padding:8px 4px;text-align:center;}",
    ".ck-pt-val{font-family:'Bebas Neue',sans-serif;font-size:16px;letter-spacing:.5px;line-height:1;color:rgba(255,255,255,.7);}",
    ".ck-pt-lbl{font-size:8px;color:rgba(255,255,255,.35);margin-top:2px;letter-spacing:.3px;text-transform:uppercase;}",
    ".ck-pt-hi{background:rgba(240,192,64,.13);border-color:rgba(240,192,64,.3);}",
    ".ck-pt-hi .ck-pt-val{color:#f0c040;font-size:18px;}",
    ".ck-pt-hi .ck-pt-lbl{color:rgba(240,192,64,.65);}",
    ".ck-cta{width:100%;background:linear-gradient(135deg,#f0c040,#F4A100);border:none;border-radius:12px;padding:17px 16px;font-family:'Bebas Neue',sans-serif;font-size:22px;letter-spacing:3px;color:#000;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:10px;animation:ck-pulse 2s ease-in-out infinite;margin-bottom:10px;text-decoration:none;}",
    ".ck-cta:hover{filter:brightness(1.05);}",
    ".ck-cta-tag{background:rgba(0,0,0,.15);border-radius:4px;padding:2px 8px;font-size:11px;letter-spacing:1.5px;font-weight:700;}",
    ".ck-hfoot{display:flex;align-items:center;justify-content:center;}",
    ".ck-hfoot-txt{font-size:10px;color:rgba(255,255,255,.3);}",
    ".ck-bottom{padding:14px 16px 24px;background:#f0ede8;}",
    ".ck-cd{display:flex;align-items:center;justify-content:center;gap:6px;background:#111;border-radius:10px;padding:10px 14px;margin-bottom:10px;}",
    ".ck-cd-lbl{font-size:10px;color:#555;}",
    ".ck-cd-time{font-family:'Bebas Neue',sans-serif;font-size:24px;color:#f0c040;letter-spacing:3px;min-width:88px;text-align:center;}",
    ".ck-cd-sub{font-size:10px;color:#444;}",
    ".ck-proof{display:flex;align-items:center;gap:8px;background:#fff;border:1.5px solid #e6e1d9;border-radius:10px;padding:9px 12px;}",
    ".ck-proof-avs{display:flex;}",
    ".ck-av{width:24px;height:24px;border-radius:50%;background:#e0dbd4;border:2px solid #f0ede8;margin-left:-6px;font-size:11px;display:flex;align-items:center;justify-content:center;}",
    ".ck-av:first-child{margin-left:0;}",
    ".ck-proof-txt{font-size:11px;color:#666;flex:1;line-height:1.4;}",
    ".ck-proof-txt strong{color:#111;font-weight:600;}",
  ].join('');

  // ── HTML BUILDERS ────────────────────────────────────────────────
  function teamMatchup(d) {
    var logo1 = d.team1Logo ? '<img class="ck-team-logo" src="' + d.team1Logo + '" alt="' + d.team1 + '">' : '';
    var logo2 = d.team2Logo ? '<img class="ck-team-logo" src="' + d.team2Logo + '" alt="' + d.team2 + '">' : '';
    return '<div class="ck-matchup">'
      + '<div class="ck-team-pill">' + logo1 + '<span class="ck-team-name">' + d.team1 + '</span></div>'
      + '<span class="ck-vs">VS</span>'
      + '<div class="ck-team-pill">' + logo2 + '<span class="ck-team-name">' + d.team2 + '</span></div>'
    + '</div>';
  }

  function buildHero(d) {
    var dateStr = d.date || '';
    var timeStr = d.startTime ? ' \u00b7 ' + d.startTime : '';
    return '<div class="ck-hero">'
      + '<div class="ck-ring"></div><div class="ck-ring2"></div>'
      + '<div class="ck-hi">'
        + '<div class="ck-chip"><span class="ck-chip-txt">' + dateStr + timeStr + '</span><span class="ck-chip-live">&#9679; OPEN</span></div>'
        + teamMatchup(d)
        + '<div class="ck-hero-top">'
          + '<div>'
            + '<div class="ck-eyebrow">Free to play \u00b7 IPL 2026</div>'
            + '<div class="ck-title">WIN A<em>IPL TICKET</em></div>'
          + '</div>'
          + '<div class="ck-emoji">&#127967;</div>'
        + '</div>'
        + '<div class="ck-sub">Pick winner, predict the score, name the top bat &amp; bowler. <strong>Closest predictions win \u2014 top score takes a FREE IPL ticket.</strong> 30 seconds.</div>'
        + '<div class="ck-steps">'
          + '<div class="ck-step"><span class="ck-step-icon">&#127942;</span><span class="ck-step-txt">Pick winner</span></div>'
          + '<div class="ck-step"><span class="ck-step-icon">&#128202;</span><span class="ck-step-txt">Predict score</span></div>'
          + '<div class="ck-step"><span class="ck-step-icon">&#127951;</span><span class="ck-step-txt">Top batsman</span></div>'
          + '<div class="ck-step"><span class="ck-step-icon">&#9889;</span><span class="ck-step-txt">Top bowler</span></div>'
        + '</div>'
        + '<div class="ck-pts">'
          + '<div class="ck-pt"><div class="ck-pt-val">500</div><div class="ck-pt-lbl">Team score</div></div>'
          + '<div class="ck-pt"><div class="ck-pt-val">300</div><div class="ck-pt-lbl">Bat runs</div></div>'
          + '<div class="ck-pt"><div class="ck-pt-val">200</div><div class="ck-pt-lbl">Bowl wkts</div></div>'
          + '<div class="ck-pt ck-pt-hi"><div class="ck-pt-val">&#127967;</div><div class="ck-pt-lbl">Top score</div></div>'
        + '</div>'
        + '<a href="' + window.location.origin + '/pages/predict-and-win" class="ck-cta" id="ck-cta-btn">PREDICT NOW <span class="ck-cta-tag">FREE</span></a>'
        + '<div class="ck-hfoot"><span class="ck-hfoot-txt">Free entry \u00b7 no spam \u00b7 closes at match start</span></div>'
      + '</div>'
    + '</div>';
  }

  function buildBottom(d) {
    var total = (d.polls && d.polls.total) || 0;
    var countStr = total > 0 ? total.toLocaleString('en-IN') + ' people' : 'People';
    return '<div class="ck-cd">'
        + '<span class="ck-cd-lbl">Closes in</span>'
        + '<span class="ck-cd-time" id="ck-cd">--:--:--</span>'
        + '<span class="ck-cd-sub">\u00b7 at match start</span>'
      + '</div>'
      + '<div class="ck-proof">'
        + '<div class="ck-proof-avs">'
          + '<div class="ck-av">\ud83d\ude0a</div><div class="ck-av">\ud83e\udd29</div><div class="ck-av">\ud83d\ude0e</div><div class="ck-av">\ud83c\udfcf</div>'
        + '</div>'
        + '<div class="ck-proof-txt"><strong id="ck-pax">' + countStr + '</strong> already predicted today</div>'
      + '</div>';
  }

  function buildPopup(d) {
    return '<div class="ck-drag"><div class="ck-drag-bar"></div></div>'
      + '<div id="ck-popup">'
        + '<div class="ck-ph">'
          + '<div class="ck-logo">WONDER<em>BETTER</em></div>'
          + '<div class="ck-live"><div class="ck-live-dot"></div><span class="ck-live-txt">LIVE NOW</span></div>'
          + '<button class="ck-close" id="ck-close-btn">&#10005;</button>'
        + '</div>'
        + buildHero(d)
        + '<div class="ck-bottom" id="ck-bottom">' + buildBottom(d) + '</div>'
      + '</div>';
  }

  // ── COUNTDOWN ────────────────────────────────────────────────────
  function startCountdown(closeTs) {
    if (cdTimer) clearInterval(cdTimer);
    function tick() {
      var diff = Math.max(0, closeTs - Date.now());
      var el = document.getElementById('ck-cd');
      if (el) el.textContent = String(Math.floor(diff / 3600000)).padStart(2,'0') + ':' + String(Math.floor((diff % 3600000) / 60000)).padStart(2,'0') + ':' + String(Math.floor((diff % 60000) / 1000)).padStart(2,'0');
      if (diff <= 0) clearInterval(cdTimer);
    }
    tick();
    cdTimer = setInterval(tick, 1000);
  }

  // ── PAX TICKER ───────────────────────────────────────────────────
  function startPaxTicker(n) {
    if (paxTimer) clearTimeout(paxTimer);
    function tick() {
      n += Math.floor(Math.random() * 2) + 1;
      var el = document.getElementById('ck-pax');
      if (el) el.textContent = n.toLocaleString('en-IN') + ' people';
      paxTimer = setTimeout(tick, 5000 + Math.random() * 8000);
    }
    paxTimer = setTimeout(tick, 4000);
  }

  // ── BUBBLE ───────────────────────────────────────────────────────
  function createBubble(d) {
    bubbleEl = document.createElement('div');
    bubbleEl.id = 'ck-predict-bubble';
    bubbleEl.innerHTML = '<div class="ck-bubble-icon">'
      + '<span class="ck-bubble-emoji">\ud83c\udfcf</span>'
      + '<div class="ck-bubble-badge"><div class="ck-bubble-badge-dot"></div></div>'
    + '</div>';
    bubbleEl.addEventListener('click', function() { openPopup(d); });
    document.body.appendChild(bubbleEl);
  }

  // ── POPUP OPEN / CLOSE ───────────────────────────────────────────
  function openPopup(d) {
    if (overlayEl) {
      overlayEl.classList.add('ck-on');
      if (bubbleEl) bubbleEl.classList.add('ck-hidden');
      return;
    }
    overlayEl = document.createElement('div');
    overlayEl.id = 'ck-predict-overlay';
    overlayEl.innerHTML = buildPopup(d);
    document.body.appendChild(overlayEl);
    requestAnimationFrame(function() { requestAnimationFrame(function() { overlayEl.classList.add('ck-on'); }); });
    if (bubbleEl) bubbleEl.classList.add('ck-hidden');

    document.getElementById('ck-close-btn').addEventListener('click', function() { closePopup(d.matchNo); });
    overlayEl.addEventListener('click', function(e) { if (e.target === overlayEl) closePopup(d.matchNo); });

    var ctaBtn = document.getElementById('ck-cta-btn');
    if (ctaBtn) ctaBtn.addEventListener('click', function(e) {
      e.preventDefault();
      closePopup(d.matchNo);
      window.location.href = window.location.origin + '/pages/predict-and-win';
    });

    startCountdown(d.closeTimestamp || (Date.now() + 4 * 3600000));
    var total = (d.polls && d.polls.total) || 0;
    if (total > 0) startPaxTicker(total);
  }

  function closePopup(matchNo) {
    if (overlayEl) overlayEl.classList.remove('ck-on');
    try { localStorage.setItem(POPUP_KEY, String(matchNo)); } catch(e) {}
    setTimeout(function() { if (bubbleEl) bubbleEl.classList.remove('ck-hidden'); }, 350);
  }

  // ── INIT ─────────────────────────────────────────────────────────
  function injectCSS() {
    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  var retryCount = 0;

  function init() {
    fetch(API + '?action=getContest')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (d && d.status === 'active') {
          injectCSS();
          createBubble(d);
        } else if (retryCount < 3) {
          setTimeout(init, ++retryCount * 3000);
        }
      })
      .catch(function() { if (retryCount < 3) setTimeout(init, ++retryCount * 3000); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();